/*==============MENU SLIDER==============*/
$(document).ready(function(){
    $(document).mousemove(function(){
         if($("header:hover").length != 0){            
        } else{
            jQuery('.site-nav__details').removeAttr('open');
        }
    });
  
    // mySlickInit('.menu-carousel-wrapper-1');
    // mySlickInit('.menu-carousel-wrapper-2');
    // mySlickInit('.menu-carousel-wrapper-3');
    // mySlickInit('.menu-carousel-wrapper-4');
    // mySlickInit('.menu-carousel-wrapper-5'); 
    // mySlickInit('.menu-carousel-wrapper-6'); 
    // mySlickInit('.menu-carousel-wrapper-7'); 
    // mySlickInit('.menu-carousel-wrapper-8');
    // mySlickInit('.menu-carousel-wrapper-9');
    // mySlickInit('.menu-carousel-wrapper-10');
    mySlickInit('.nav-carousel-wrapper');    
  
    //$(window).trigger('resize');
   function mySlickInit(selector) {
      $(selector).slick({
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: false,
        mobileFirst:true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: true,
        touchMove: true,
        swipe: true,
        prevArrow: '<div class="slick-prev" style="transform: rotate(92deg);"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16" style="height: 20px; width:20px;"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg></div>',
        nextArrow: '<div class="slick-next" style="transform: rotate(270deg);"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16" style="height: 20px; width:20px;"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg></div>',
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              variableWidth: true
            }
          }
        ]
      });
   }

  /* Sticky Add To Cart */
  if ($(window).width() <= 768) {
    var $button = $('form.product-single__form');
    var offset = $button.offset().top;
    
    $(window).scroll(function() {
      if ($(window).scrollTop() > offset) {
          $button.addClass('sticky');
      } else {
          $button.removeClass('sticky');
      }
    });
  }
});

$(document).on("touchstart",".site-nav__details",function() {
  $('.menu-carousel-wrapper-1').slick('refresh');
  $('.menu-carousel-wrapper-2').slick('refresh');
  $('.menu-carousel-wrapper-5').slick('refresh');
  $('.menu-carousel-wrapper-8').slick('refresh');
});

/*============== MENU SLIDER END ==============*/

/* 
const applyDelay = ms => new Promise(res => setTimeout(res, ms));

function findObjectByKey(array, key, value, multiple) {
  try {
    let rtn = [];
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        if ( multiple ) {
          rtn.push( array[i] );
        } else {
          return array[i];
        }
      }
    }

    if ( multiple && rtn.length > 0 ) {
      return rtn;
    } else {
      return null;
    }
  } catch ( err ) {
   
  }
}
function ParseFloat( str, val ) {
  str = str.toString();
  str = str.slice(0, (str.indexOf(".")) + val + 1);
  return Number(str);
}  
function getParam ( paramIs ) {
  try {
    const url                     =   location.href;
    const objURL                  =   new URL(url);
    const c                       =   objURL.searchParams.get( paramIs );
    return c;
  } catch ( err ) {  
    console.log ( 'ERROR getParam', err.message );
  }  
}
*/ 
      $(document).ready(function(){
      $('.variant-input[data-index="option1"]').on('click', function() {
        console.log('click____-');
      var selected_val = $(this).find('label').attr('data-price_disc');
        if(selected_val){
          $('.product-priceDiscountPercentage').html(selected_val+' Rabatt');
        }else{
          $('.product-priceDiscountPercentage').html('');
        }
      });
    $('.collapsible-trigger[data-collapsible-id="filter-grosse"]').click(function(){
      
      $('.tag').addClass('available');
    });

          });
